import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_editor_viewer = _resolveComponent("editor-viewer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_editor_viewer, {
    "html-content": _ctx.pageHtmlContent
  }, null, 8, ["html-content"])]);
}